mutation RunMerchTest($merchOverlayId: ID!, $action: StreamToolsMerchTestAction!, $state: Int, $broadcast: Boolean) {
  result: StreamToolsRunMerchTest(
    merchOverlayId: $merchOverlayId
    action: $action
    state: $state
    broadcast: $broadcast
  ) {
    merchOverlayId
    version
    order
    state
    boards {
      merchOverlayId
      ok
      state
      error
    }
  }
}
